<template>
  <div class="rutas">
    <div class="portada">
      <h1 class="titulo">
        Rutas
      </h1>
      <p class="bajada">
        Recorridos armados a mano: qué visitar, en qué orden y dónde parar.
        Empresas y lugares de la sabana, uno detrás de otro.
      </p>
    </div>

    <div class="barra">
      <v-text-field
        v-model="filtroTexto"
        label="Buscar por nombre, ciudad o descripción"
        prepend-inner-icon="mdi-magnify"
        variant="outlined"
        density="compact"
        hide-details
        clearable
        @keydown.enter="buscar"
        @click:clear="limpiar"
      />
      <v-btn
        color="primary"
        variant="tonal"
        @click="buscar"
      >
        Buscar
      </v-btn>
    </div>

    <div
      v-if="cargando"
      class="estado"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>

    <div
      v-else-if="error"
      class="estado"
    >
      <v-icon
        size="42"
        color="error"
      >
        mdi-alert-circle-outline
      </v-icon>
      <span>{{ error }}</span>
      <v-btn
        color="primary"
        size="small"
        @click="cargar"
      >
        Reintentar
      </v-btn>
    </div>

    <div
      v-else-if="rutas.length === 0"
      class="estado"
    >
      <v-icon
        size="52"
        color="grey-lighten-1"
      >
        mdi-map-marker-path
      </v-icon>
      <span v-if="filtroTexto">No encontramos ninguna ruta con esa búsqueda.</span>
      <span v-else>Todavía no hay rutas publicadas. Vuelve pronto.</span>
    </div>

    <div
      v-else
      class="rejilla"
    >
      <TarjetaRuta
        v-for="ruta in rutas"
        :key="ruta.idRoute"
        :ruta="ruta"
        @abrir="abrir"
      />
    </div>

    <v-pagination
      v-if="totalPaginas > 1"
      v-model="paginaVisible"
      :length="totalPaginas"
      :total-visible="5"
      density="comfortable"
      active-color="primary"
      class="mt-5"
      @update:model-value="cambiarPagina"
    />
  </div>
</template>

<script>
import apisRutas from '@/apis/apisRutas'
import TarjetaRuta from '@/components/Rutas/TarjetaRuta.vue'
import { mensajeDeError } from '@/utils/errores'
import { ponerTitulo } from '@/router'

/**
 * Rutas, para visitantes.
 *
 * Solo salen las rutas activas, y cada tarjeta cuenta las paradas VISIBLES: una
 * parada de una empresa sin hospedaje vigente no se cuenta ni se muestra. Eso
 * lo decide el backend, aqui solo se pinta.
 */
export default {
  name: 'RutasView',
  components: { TarjetaRuta },
  data() {
    return {
      rutas: [],
      cargando: true,
      error: null,
      filtroTexto: '',
      pagina: 0,
      totalPaginas: 1
    }
  },
  computed: {
    /** v-pagination cuenta desde 1 y el backend desde 0. */
    paginaVisible: {
      get() {
        return this.pagina + 1
      },
      set(valor) {
        this.pagina = valor - 1
      }
    }
  },
  created() {
    this.cargar()
  },
  methods: {
    cargar() {
      this.cargando = true
      this.error = null

      apisRutas.buscarPublicas(this.filtroTexto || '', this.pagina)
        .then(respuesta => {
          this.rutas = respuesta.content || []
          this.totalPaginas = respuesta.totalPages || 1
        })
        .catch(error => {
          this.error = mensajeDeError(error, 'No se pudieron cargar las rutas')
        })
        .finally(() => {
          this.cargando = false
        })
    },
    buscar() {
      this.pagina = 0
      this.cargar()
    },
    limpiar() {
      this.filtroTexto = ''
      this.buscar()
    },
    cambiarPagina() {
      this.cargar()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    abrir(ruta) {
      // Por slug y no por id: es la URL que se comparte y la que posiciona
      ponerTitulo(ruta.name)
      this.$router.push({ name: 'ViewRutaView', params: { slug: ruta.slug } })
    }
  }
}
</script>

<style scoped>
/* Mobile first: una columna, y mas segun crece la pantalla */
.rutas {
  max-width: 1240px;
  margin: 0 auto;
  padding: 18px 14px 48px;
}

.portada {
  margin-bottom: 20px;
}
.titulo {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 800;
  color: #1a1a1a;
}
.bajada {
  margin: 6px 0 0;
  max-width: 560px;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #667085;
}

.barra {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 18px;
}
@media (min-width: 700px) {
  .barra {
    flex-direction: row;
    align-items: center;
    max-width: 620px;
  }
}

/* Una tarjeta por fila, a todo el ancho.
   Antes eran tres columnas y la tarjeta quedaba estrecha: no cabia mas que una
   foto y dos lineas de texto. En fila hay sitio para la portada, la tira del
   resto de paradas y la descripcion completa, que es lo que deja escoger una
   ruta sin tener que abrirla. */
.rejilla {
  display: grid;
  /* minmax(0, 1fr) y no 1fr: si no, un nombre largo sin espacios ensancha la
     columna y desborda la rejilla */
  grid-template-columns: minmax(0, 1fr);
  gap: 14px;
}

.estado {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 64px 12px;
  color: #667085;
  font-size: 0.92rem;
  text-align: center;
}
</style>
